import React from 'react';
import "./Sidebar.css";
import SidebarOption from "./SidebarOption";
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';
import { getTokenFromResponse } from "./spotify";
import { UseDataLayerValue } from './DataLayer';

function Sidebar() {
  const [{ playlists }, dispatch] = UseDataLayerValue();
  console.log(playlists);
  return (
    <div className='sidebar'>
      <img className='sidebar_logo' src="https://getheavy.com/wp-content/uploads/2019/12/spotify2019-830x350.jpg" alt="" />
      <SidebarOption Icon={HomeIcon} title="Home" />
      <SidebarOption Icon={SearchIcon} title="Search" />
      <SidebarOption Icon={LibraryMusicIcon} title="Your Library" />

      <br />
      <strong className="sidebar__title">PLAYLISTS</strong>
      <hr />
      {playlists && playlists.items && playlists.items.map((playlist) => (
        <SidebarOption option={playlist.name} />
      ))}
    </div>

  )
}

export default Sidebar;